export enum DesktopBroadcastMessages {
  REMOVE_ITEM = 'REMOVE_ITEM'
}

interface RemoveItemMessage {
  type: DesktopBroadcastMessages.REMOVE_ITEM
  payload: { id: string }
}

export type DesktopBroadcastMessage = RemoveItemMessage
